import { useEffect } from "react";
import { createFileRoute } from "@tanstack/react-router";
import { MissionKit } from "@/features/missionkit/mission-kit";
import { useMission } from "@/features/missionkit/api/use-mission";

export const Route = createFileRoute("/missionkit_/code/$code/$missionId")({
  component: MissionKitRoute,
});

/**
 * The mission kit link sent by SMS — `/missionkit/code/<code>/<missionId>`.
 * `<code>` is the visitor's KEY code (same one `/code/<code>` carries, kept so
 * the kit knows who it belongs to); `<missionId>` is the glow.missionbank row
 * they accepted. Trailing `_` in the filename keeps this out of the
 * `/missionkit` layout.
 */
function MissionKitRoute() {
  const { code, missionId } = Route.useParams();
  const { data, isPending, isError } = useMission(missionId);

  // Same as the /code/<code> landing: remember whose key this is.
  useEffect(() => {
    if (code) localStorage.setItem("secret-missions-ref", code);
  }, [code]);

  if (isPending) {
    return (
      <p className="text-center font-mono text-[11px] tracking-[0.22em] text-muted-foreground uppercase">
        Opening the case…
      </p>
    );
  }

  if (isError || !data) {
    return (
      <p className="text-center font-mono text-[11px] tracking-[0.22em] text-muted-foreground uppercase">
        Those orders could not be found.
      </p>
    );
  }

  return <MissionKit missionId={missionId} />;
}
